define(["mw-remote/serviceRegistryLookup","/mathworks/devel/bat/filer/batfs1301-0/Cdoctools2p.2370998/build/scm/development-docsurvey/0.3.0/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "", __webpack_require__.dj.c(), true);
});